import styled, { css } from 'styled-components'

type NumericalCardProps = {
  backgroundColor?: string
  titleColor?: string
  descriptionColor?: string
}

export const NumericalCard = styled.article<NumericalCardProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  gap: 8px;
  width: 100%;
  padding: 10px 24px;
  border-radius: 32px;

  ${(props) =>
    props.backgroundColor &&
    css`
      background-color: ${props.backgroundColor};
    `}
  .numerical-card-title {
    color: ${(props) => props.titleColor || props.theme.colors.primary};
    display: flex;
    gap: 10px;
    align-items: flex-end;
    .subtitle {
      margin-bottom: 7px;
    }
  }
  .numerical-card-description {
    color: ${(props) => props.descriptionColor || props.theme.colors.white};
    text-align: center;
  }

  @media (max-width: 1080px) {
    .numerical-card-title {
      font-size: ${(props) => props.theme.fontSizes.h4};
    }
    .numerical-card-description {
      font-size: ${(props) => props.theme.fontSizes.b2};
    }
  }

  @media (max-width: 768px) {
    border-radius: 8px;
  }
`

export const StarScoreContainer = styled.div<NumericalCardProps>`
  max-width: 50%;

  @media (max-width: 768px) {
    max-width: 50%;
  }
`
